export default __webpack_public_path__ + "static/pie_chart_animated-d7211153942ffeef7e90512445f48e6f.mp4";